import { useGSAP } from "@gsap/react";
import { chipImg, frameImg, frameVideo } from "../utils";
import gsap from "gsap";
import { useRef } from "react";
import { animateWithGsap } from "../utils/animations";

const HowItWorks = () => {
  const videoRef = useRef();

  useGSAP(() => {
    gsap.from("#chip", {
      scrollTrigger: {
        trigger: "#chip",
        start: "top 75%",
      },
      opacity: 0,
      scale: 1,
      duration: 2,
      ease: "power2.inOut",
    });

    gsap.from("#hiw-video", {
      scrollTrigger: {
        trigger: "#hiw-video",
        start: "top 75%",
        onEnter: () => {
          videoRef.current.play();
        },
        once: true,
      },
      opacity: 0,
      scale: 1,
      duration: 2,
      ease: "power2.inOut",
    });

    animateWithGsap(".g_fadeIn", {
      opacity: 1,
      y: 0,
      duration: 1,
      ease: "power2.inOut",
    });
  }, []);

  return (
    <section className="common-padding">
      <div className="screen-max-width">
        <div id="chip" className="flex-center w-full my-20">
          <img src={chipImg} alt="chip" width={180} height={180} />
        </div>
        <div className="flex flex-col items-center">
          <h2 className="hiw-title">
            A19 Pro chip.
            <br /> A Monster win for gaming
          </h2>

          <p className="hiw-subtitle">
            It's here. The biggest redesign in the history of Apple GPUs.
          </p>
        </div>

        <div className="mt-10 md:mt-20 mb-14">
          <div className=" relative h-full flex-center">
            <div className="overflow-hidden">
              <img
                src={frameImg}
                alt="frame"
                className="bg-transparent relative z-10"
              />
            </div>
            <div className="hiw-video" id="hiw-video">
              <video
                className="pointer-events-none"
                playsInline
                preload="auto"
                muted
                autoPlay={false}
                ref={videoRef}
              >
                <source src={frameVideo} type="video/mp4" ref={videoRef} />
              </video>
            </div>
          </div>

          <p className="text-gray font-semibold text-center mt-3">
            Naruto Mobile: Pain vs Six Tails
          </p>
          <div />

          <div className="hiw-text-container mt-10">
            <div className="flex flex-1 justify-center flex-col">
              <p className="hiw-text g_fadeIn">
                A19 Pro is an entirely new class of iPhone chip that delivers
                our{" "}
                <span className="text-white">
                  best graphic performance by far
                </span>
              </p>

              <p className="hiw-text g_fadeIn">
                Mobile{" "}
                <span className="text-white">
                  games will look and feel so immersive.
                </span>
                , with incredibly detailed enviroments and characters
              </p>
            </div>

            <div className="flex-1 flex justify-center flex-col g_fadeIn">
              <p className="hiw-text">New</p>
              <p className="hiw-bigtext">A19 Pro chip</p>
              <p className="hiw-text">with 8-core GPU</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
